import { Package, Users, Wrench, Wallet, ShieldCheck, User as UserIcon } from 'lucide-react'

export type CustomerNavKey =
  | 'products'
  | 'customers'
  | 'utilities'
  | 'topup'
  | 'policy'
  | 'profile'

export type CustomerNavItem = {
  key: CustomerNavKey
  label: string
  path: `/${string}`
  icon: typeof Package
  requiresAuth?: boolean
}

export const customerNavItems: readonly CustomerNavItem[] = [
  { key: 'products', label: 'Sản phẩm', path: '/products', icon: Package },
  { key: 'topup', label: 'Nạp tiền', path: '/topup', icon: Wallet, requiresAuth: true },
  { key: 'utilities', label: 'Tiện ích', path: '/utilities', icon: Wrench, requiresAuth: true },
  { key: 'customers', label: 'Khách hàng', path: '/customers', icon: Users },
  { key: 'policy', label: 'Thông tin', path: '/policy', icon: ShieldCheck },
  { key: 'profile', label: 'Hồ sơ', path: '/profile', icon: UserIcon, requiresAuth: true },
] as const
